<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
            <vue-headful :title="jsa.jsa_name + ' [JSA Templates] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/jsa/templates`">
                            <i class="fa fa-files-o"></i> JSA Templates
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ jsa.jsa_name }}
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-lg-8">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>{{ jsa.jsa_name }}</strong>

                            <div class="pull-right">
                                <router-link :to="`/jsa/templates/print/${jsa.jsa_id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-file-pdf-o"></i> PDF
                                </router-link>
                                <router-link :to="`/jsa/templates/edit/${jsa.jsa_id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <b-button variant="light" size="sm" v-on:click="cloneJSA()"><i class="fa fa-copy"></i> Clone</b-button>
                                <router-link :to="`/jsa/templates/delete/${jsa.jsa_id}`" class="btn btn-sm btn-light">
                                    <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                                </router-link>
                            </div>

                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col text-muted">JSA Name</div>
                                <div class="col-md-8">{{ jsa.jsa_name }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Created By</div>
                                <div class="col-md-8"><user-name :user="jsa" /></div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Contractor</div>
                                <div class="col-md-8">{{ jsa.jsa_contractor }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Active</div>
                                <div class="col-md-8">
                                    <span class="badge badge-success" v-if="jsa.is_active == 1">Active</span>
                                    <span class="badge badge-warning" v-else>Inactive</span>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Total # of Steps</div>
                                <div class="col-md-8">{{ totalSteps }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Total # of Hazards</div>
                                <div class="col-md-8">{{ totalHazards }}</div>
                            </div>

                            <hr/>

                            <div class="row mb-2">
                                <div class="col text-muted">Building/Area:</div>
                                <div class="col-md-8">{{ jsa.jsa_building_area }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Description of Work:</div>
                                <div class="col-md-8">{{ jsa.jsa_description }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Standard PPE:</div>
                                <div class="col-md-8">{{ jsa.jsa_safety_equipment }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Specialized PPE:</div>
                                <div class="col-md-8">{{ jsa.jsa_specialized_equipment }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Monitoring Activities:</div>
                                <div class="col-md-8">{{ jsa.jsa_monitoring_act }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <b-tabs class="nav-tabs-top mb-4">
                <b-tab active>
                    <template slot='title'>
                        Steps and Hazards
                    </template>
                    <b-card-body>
                        <ol>
                           <li v-for="step in jsa.jsa_steps" class="mb-2">
                                {{ step.step_label }}
                                <ul>
                                   <li v-for="hazard in step.hazards" class="mb-1">
                                        <span :class="`badge badge-${getRacLevelColor(hazard.rac_level)}`">{{ hazard.rac_level }}</span>
                                        {{ hazard.hazard }}
                                        |
                                        <span class="text-primary" title="Standard Controls">
                                            <template v-for="(control, index) in hazard.controls"><template v-if="index > 0">, </template>{{ control }}</template>
                                            <template v-if="hazard.other_controls">{{ hazard.other_controls }}</template>
                                        </span>
                                   </li>
                                </ul>
                           </li>
                        </ol>
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                jsa_id: this.$route.params.id,
                jsa: {},
            }
        },

        watch: {
            new_file(newVal, oldVal){
                //Check for null
                if(newVal == null)
                {
                    return;
                }

                //Save it
                this.saveNewFile();
            },
        },

        computed: {

            totalSteps(){
                //Send it
                return this.jsa.jsa_steps.length;
            },

            totalHazards(){
                //Start it
                var t = 0;

                //Loop and count
                for (var i = this.jsa.jsa_steps.length - 1; i >= 0; i--)
                {
                    t += this.jsa.jsa_steps[i].hazards.length;
                }

                //Send it
                return t;
            },
        },

        methods: {

            cloneJSA(){
                //Confirm it
                if(!confirm('Are you sure you want to clone this JSA Template?'))
                {
                    return;
                }

                //Send it
                this.cloning = true;

                //Send it
                this.$http
                    .post('jsa/templates/clone/' + this.jsa_id)
                    .then(response => {
                        //Return to main list?
                        this.$router.push('/jsa/templates/edit/' + response.data.jsa_id);
                    })
                    .catch(response => {

                    })
                    .then(response => {
                        //Rest
                        this.cloning = false;
                    });
            },

            getRacLevelColor(level){
                //switch
                switch(level)
                {
                    case 'Extremely High':
                        return 'danger';
                        break;
                    case 'High':
                        return 'orange';
                        break;
                    case 'Medium':
                        return 'warning';
                        break;
                    case 'Low':
                        return 'success';
                        break;

                }

                return 'success';
            },

            getJsa: function() {
                //Get the data
                this.$http
                    .get('jsa/templates/view/' + this.jsa_id)
                    .then(response => {
                        //Set all the data
                        this.jsa = response.data.jsa;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },
        },

        mounted() {
            //Get the JSA
            this.getJsa();
        }
    }
</script>
<style>
    .badge-orange {
        background-color: #ef871d;
        color: #fff;
    }
</style>
